
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[shorthand]/legal/impressum",
      function () {
        return require("private-next-pages/[shorthand]/legal/impressum.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[shorthand]/legal/impressum"])
      });
    }
  